<template>
  <div>
    <Main
      ref="main"
      :refresh="refresh"
      :loading="loading"
      :data="tableData"
      :disabled="disabled"
      :height="height"
      @reload="reload"
      @openEditDialog="(e) => $emit('openEditDialog', e)"
      @change="(e) => $emit('change', e)"
      @del-change="(e) => $emit('del-change', e)"
      @drop-change="(e) => $emit('drop-change', e)"
    >
      <Header
        ref="header"
        slot="header"
        :text="headerText"
        :disabled="disabled"
        :showAdd="showHeaderAdd"
        :showDel="showHeaderDel"
        @openEditDialog="(e) => $emit('openEditDialog', e)"
        @del="batchDel"
      />
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
export default {
  components: { Main, Header },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    refresh: { type: Boolean, default: false },
    headerText: { type: String, default: '' },
    showHeaderAdd: { type: Boolean, default: true },
    showHeaderDel: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    height: { type: Number, default: 400 },
  },
  methods: {
    reload() {
      this.$emit('reload')
    },
    reloadTableData(data) {
      this.$refs.main.reloadTableData(data)
    },
    async getTableData() {
      return this.$refs.main.getTableData()
    },
    async spliceRow(index, row) {
      this.$refs.main.spliceRow(index, row)
    },
    async insert(row) {
      this.$refs.main.insert(row)
    },
    async batchDel() {
      const data = await this.$refs.main.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }
      await this.$refs.main.removeByRows(data)
      this.$emit('del-change', data)
    },
  },
}
</script>
